import { dynamicLoader } from '~/utils';

export const ContactsPage = dynamicLoader({
  name: 'ContactsPage',
  importFunc: () => import('./contacts'),
});